export default __webpack_public_path__ + "static/media/10k-achieved.3c1faf1a.svg";